import React from 'react';
import List from 'core/modules/Partials/List/List';

function LetterboxCarousel({
  carousel, children, shouldUseCarousel, onSlideChange,
}) {
  return (
    <div className="mn_letterboxTOFCarousel">
      <List
        shouldUseCarousel={shouldUseCarousel}
        options={carousel}
        onSettle={onSlideChange}
      >
        {children}
      </List>
    </div>
  );
}

export default LetterboxCarousel;
